// GENERATED by scripts/build-icons.mjs from icons/chevrons-up-down.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ChevronsUpDown = createIcon('chevrons-up-down', [
  ['path', { d: "m7 15 5 5 5-5" }],
  ['path', { d: "m7 9 5-5 5 5" }],
])
